import React, { useState } from 'react';
import './Contact.css';
import { ContactQueryApi } from '../api/adminApi';
import Toast from './Toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    email: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({ state: 'idle', message: '' });
  const [toast, setToast] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setFormStatus({ state: 'error', message: 'Please fill in all required fields.' });
      setToast({ type: 'error', message: 'Please fill in all required fields.' });
      return;
    }
    setFormStatus({ state: 'loading', message: 'Sending your message…' });
    try {
      await ContactQueryApi.submit({
        name: formData.name.trim(),
        subject: formData.subject.trim(),
        email: formData.email.trim(),
        message: formData.message.trim(),
        source: 'homepage-contact'
      });
      setFormStatus({ state: 'success', message: "Thanks! We'll reach out shortly." });
      setFormData({ name: '', subject: '', email: '', message: '' });
      setToast({ type: 'success', message: "Thanks! We'll reach out shortly." });
    } catch (error) {
      const message = error.response?.data?.message || 'Unable to send message right now.';
      setFormStatus({ state: 'error', message });
      setToast({ type: 'error', message });
    }
  };

  return (
    <section className="contact">
      <div className="contact-container">
        <div className="contact-left">
          <div className="contact-header">
            <p className="contact-label">CONTACT</p>
            <h2 className="contact-title">Contact Us</h2>
            <p className="contact-description">
              Have questions or need more information? Reach out to us using the form below or contact us directly.
            </p>
          </div>

          <div className="contact-info">
            <h3 className="contact-info-title">Contact Info :</h3>
            <div className="contact-info-items">
              <div className="contact-info-item">
                <div className="contact-icon email-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span>tanya.hill@example.com</span>
              </div>
              <div className="contact-info-item">
                <div className="contact-icon phone-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 16.92V19.92C22 20.92 21.1 21.82 20.1 21.82C9.5 21.32 2.68 14.5 2.18 3.9C2.18 2.9 3.08 2 4.08 2H7.08C8.08 2 8.98 2.9 8.98 3.9C8.98 5.9 9.38 7.8 10.08 9.5C10.28 10 10.18 10.6 9.78 11L8.18 12.6C9.78 15.8 12.2 18.2 15.4 19.8L17 18.2C17.4 17.8 18 17.7 18.5 17.9C20.2 18.6 22.1 19 24.1 19C25.1 19 26 19.9 26 20.9V23.9C26 24.9 25.1 25.8 24.1 25.8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span>(480) 555-0103</span>
              </div>
              <div className="contact-info-item">
                <div className="contact-icon location-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span>2464 Royal Ln. Mesa, New Jersey 45463</span>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-right">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="form-input name-input"
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>
            <input
              type="email"
              name="email"
              placeholder="Email ID"
              value={formData.email}
              onChange={handleChange}
              className="form-input full-width"
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
              rows="5"
              required
            />
            <button type="submit" className="submit-button" disabled={formStatus.state === 'loading'}>
              {formStatus.state === 'loading' ? 'Sending…' : 'Submit'}
            </button>
            {formStatus.state === 'loading' && (
              <span className="contact-form-feedback loading" role="status" aria-live="polite">
                Sending your message…
              </span>
            )}
          </form>
        </div>
      </div>
      <Toast
        message={toast?.message}
        type={toast?.type}
        onDismiss={() => setToast(null)}
      />
    </section>
  );
};

export default Contact;
